import React from 'react';

import { Button } from '../../../components-core/packages/components-core/dist/button/index';

import { 
    Container, 
    ContainerGutter, 
    ContainerWrap,
    ContainerHorizontalAlignment, 
    ContainerVerticalAlignment,
    ContainerPadding
} from '../../../components-core/packages/components-core/dist/container/index';

import {
    ThemeProvider,
    styled
} from '../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Text,
    TextAppearance,
    TextColor,
    TextAlignment,
} from '../../../components-core/packages/components-core/dist/text/index';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';
import { Checkmark } from '../../../components-core/packages/icons-core/dist/Checkmark/index';


const ColorContainer = styled.div`
    background-color: ${props => props.backgroundColor};
    min-height: 180px;
    padding-top: 24px;
    width: 100%;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 24px;
`;

const CenterContentContainer = styled(ContentContainer)`
    align-items: center;
`;

const ImageContainer = styled.div`
    margin-top: -22%;
`;

const TextContainer = styled.div`
    padding: 0 32px 0 32px;
`; 

class MaintenancePrice extends React.Component {

    renderPrice() {
        return (
            <Text textAlign={TextAlignment.center}  appearance={TextAppearance.label0200} >
                <b>{this.props.data.price}</b>'den başlayan fiyatlarla
            </Text>  
        )
    }

    renderSpecifications(){
        return listItems.map(item => 
            <Container 
                wrap={ContainerWrap.never}
                gutter={ContainerGutter.static100} 

            >
                <Checkmark variant={'small'} style={{ color: '#ff0000' }} />
                <Text appearance={TextAppearance.copy0150}>{item}</Text>
            </Container>
        )
    }

    renderContainer(modelLink) {
        return (
           
                <CenterContentContainer>
                {this.renderPrice()}<br/>
                {this.renderSpecifications()}
                {this.renderButton(modelLink)}
                </CenterContentContainer>
                
        )
    }

    renderButton(modelLink) {
        return (
            <Container 
                stretchContent={true} 
                padding={{ 
                    top: ContainerPadding.dynamic0050,
                    bottom: ContainerPadding.dynamic0050
                }}
                gutter={ContainerGutter.static100} 

            >
              <Button stretchContent={true} onClick={() => window.open(modelLink)}>
                    <Text 
                        appearance={TextAppearance.label0150} 
                        color={TextColor.inherit}
                    >
                        Trendline ile karşılaştır
                    </Text>
                </Button>
                <Button stretchContent={true} onClick={() => window.open(modelLink)}>
                    <Text 
                        appearance={TextAppearance.label0150} 
                        color={TextColor.inherit}
                    >
                        Modeli incele
                    </Text>
                </Button>
              
            </Container>
        )
    }
    
    render() {
        return [
            <ThemeProvider theme={'image'}>
                <ColorContainer backgroundColor={this.props.data.backgroundColor}>
                    <TextContainer>
                        <Text bold appearance={TextAppearance.headline0250}>
                            {this.props.data.title}
                        </Text>
                    </TextContainer>
                </ColorContainer>
            </ThemeProvider>,
            <ThemeProvider theme={'main'} >
                <ImageContainer>
                    <Image 
                        src={this.props.data.image}
                        alt={this.props.data.title}
                    />
                </ImageContainer>
                {this.renderContainer(this.props.modelLink)}
            </ThemeProvider>
        ]
    }

}

const listItems = [
    'Servis indirim oranınızı görün', 
    'Online servis randevunuzu kolayca alın',
    'Uyarı sembollerinin anlamlarını öğrenin',
    'Tek tıkla canlı yol yardıma bağlanın'
]

export default MaintenancePrice;